import React, { Component } from 'react';
import Page from '../components/Page';

class About extends Component{

	render(){
		
		return(
			<Page pageTitle="About">
				 <div className="clearfix card" style={{ minHeight: "20em" }}>
				 <div className="col-sm-12">
				 	<h5>ABOUT OUR MARINE CARGO COVER</h5>
					 <p>
						This policy covers loss or damage to goods and/or merchandise in transit from one place to another by sea, 
						air, rail, road. The cover provided is in the respect of marine perils, war and strike, 
						riot and civil commotion perils taken by individual who importing goods is for own use.
					 </p>
					 <p>
						This covers General Cargo which generally shipped in containers (where standard and comprehensive covers usually apply). 
						Specialized Cargo such as perishable commodities and Bulk Cargo (where specific cover is put in place).
					 </p>
					<p>
						Such policies will, if required and appropriate, cover the entire imports or export, whether by sea, 
						land or air from the seller's to the buyer's premises - including storage on the way if incidental to the shipment.
					</p>
				 </div>
				 <div className="col-sm-6">
				 	
				</div>
				 </div>
			</Page>
		);
	}
}

export default About;


// WEBPACK FOOTER //
// ./src/pages/About.jsx